import { Constructor } from '@angular/cdk/table';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

type WithHeadlineFormSectionType = {
  _initHeadline(headline: string): void;
  _initHeadlineValueChanges(getPreviousHeadline: () => string | null): void;
  _buildHeadline(): string;
};

type HeadlineFormSectionRequerimentsBase = {
  form: FormGroup;
  FORM_PATHS: { HEADLINE: () => string };
  destroy$: Subject<boolean>;
};

export function WithHeadlineFormSection<
  TBase extends Constructor<HeadlineFormSectionRequerimentsBase>
>(
  baseClass: TBase
): {
  new (...args: any[]): WithHeadlineFormSectionType;
  prototype: WithHeadlineFormSectionType;
} & TBase {
  return class WithHeadlineFormSectionable extends baseClass {
    constructor(...args: any[]) {
      super(...args);
    }

    _initHeadline(headline: string): void {
      this.form.get(this.FORM_PATHS.HEADLINE()).setValue(headline);
    }

    _initHeadlineValueChanges(getPreviousHeadline: () => string | null): void {
      this.form
        .get(this.FORM_PATHS.HEADLINE())
        .valueChanges.pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (newValue) => {
            if (newValue === getPreviousHeadline()) {
              this.form.get(this.FORM_PATHS.HEADLINE()).markAsPristine();
            }
          },
        });
    }

    _buildHeadline(): string {
      return this.form.get(this.FORM_PATHS.HEADLINE()).value;
    }
  };
}
